






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import Nomina from "@/models/tarjeta/nomina.model";
import TipoTramite from "@/models/tipoTramite";
import TramiteAplicacionNominaModel, {
  AplicacionNominaModel
} from "@/models/tramite/reclamo/aplicacion-nomina.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import Helpers from "../../helpers/helper";
@Component
export default class AplicacionNomina extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly title!: string;

  model: AplicacionNominaModel;
  constructor() {
    super();
    this.model = new AplicacionNominaModel();
  }
  onUpdateNominaTable(config: BTableConfig<Nomina>) {
    config.checkable = true;
    config.checking.check = this.onCheck;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }

  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("title", "string", true, "Título"));
    this.$emit("render", props);
  }
  @Watch("model", { deep: true })
  set(model: AplicacionNominaModel) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.descripcionReclamo = model.descripcion;
      contenido.telefonoReclamo = Helpers.Filters.PhoneToStr(model.telefono);
      contenido.tramiteAplicacionNomina = model.nominas;
      this.$emit("update:content", contenido);
    }
  }
  onCheck(nominas: Nomina[], selected: Nomina) {
    this.model.nominas = nominas.map(
      x => new TramiteAplicacionNominaModel(x.id)
    );
    this.model.descripcion = this.getComentario(nominas);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteAplicacionNomina) {
        delete contenido.descripcionReclamo;
        delete contenido.telefonoReclamo;
        delete contenido.tramiteAplicacionNomina;
      }
      this.$emit("update:content", contenido);
    }
  }
  getComentario(nominas: Nomina[]) {
    let comentarios = nominas.map(x => {
      var month = (x.month || "").toString();
      return `con el monto de RD$${x.monto} del subsidio ${
        x.subsidioCodigo
      } en el mes de ${Helpers.Filters.NumAMes(month)} del año ${x.year}`;
    });

    let result = comentarios.length
      ? `${this.tipoTramite.nombre} ${comentarios.join(", ")}`
      : "";
    return result;
  }
}
